var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerRedSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 23.0191L39.8865 26.8393L53 30.6578L39.3437 30.6192L50.853 37.989L37.7619 34.0948L46.7339 44.4155L35.2664 36.9813L40.9753 49.4173L32.0611 39.0467L34.0428 52.5903L28.4046 40.1221L26.5 53.6785L24.5954 40.1221L18.9573 52.5903L20.9389 39.0467L12.0263 49.4173L17.7336 36.9813L6.26609 44.4155L15.2381 34.0948L2.14704 37.989L13.6563 30.6192L0 30.6578L13.1135 26.8393L0 23.0191L13.6563 23.0578L2.14704 15.6895L15.2381 19.5837L6.26609 9.26302L17.7336 16.6973L12.0263 4.26125L20.9389 14.6318L18.9573 1.08664L24.5954 13.5565L26.5 0L28.4046 13.5565L34.0428 1.08664L32.0611 14.6318L40.9753 4.26125L35.2664 16.6973L46.7339 9.26302L37.7619 19.5837L50.853 15.6895L39.3437 23.0578L53 23.0191Z",
    fill: "#FE6600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerRedSun);
export default __webpack_public_path__ + "static/media/BannerRedSun.6d5491f5685cfa5ddad991ba26b7745d.svg";
export { ForwardRef as ReactComponent };